import React, {useState, useEffect} from 'react';
import Navbar from '../components/navbar';
import Education from '../components/education';
import Projects from '../components/projects';
import AboutMe from '../components/about-me';
import Social from '../components/social';
import Footer from '../components/footer';

const Home = () => {
  const [activeSection, setActiveSection] = useState('');
  useEffect(() => {
    const sectionIds = ['about', 'projects', 'education', 'social'];
    const handleScroll = () => {
    const scrollPosition = window.scrollY;
    let currentSection = '';
    // Offset to trigger section change before reaching the top
    const offset = 100; 

    for (const id of sectionIds) {
      const section = document.getElementById(id);
      if (section) {
        // Check if the user has scrolled past the top of this section
        if (section.offsetTop <= scrollPosition + offset) {
          currentSection = id;
        }
      }
    }
    // If the current section has changed, update the active section
    if (currentSection !== activeSection) {
      setActiveSection(currentSection);
    }
  };

  // Add the event listener when the component mounts
  window.addEventListener('scroll', handleScroll);

  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
  }, [activeSection]); 

  return (
  <div className="bg-white text-gray-800">
  <Navbar activeSection={activeSection} />
    <AboutMe />

    <div id="projects" className="min-h-screen  bg-white dark:bg-neutral-800 p-8">
      <Projects />
    </div>

    <div id="education" className="min-h-screen  bg-gray-100 dark:bg-neutral-900 p-8">
      <Education />
    </div>

    <div id="social" className="min-h-screen bg-white dark:bg-neutral-800 p-8">
      <Social />
    </div>

    <Footer />
  </div>
  );
  }

export default Home;